import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import type { CreditCardOffer } from '@cc-shopping/contracts/cross-site/marketplace/types';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { FinishType } from '@cc-shopping/platform-analytics/types';
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import { Box } from '@mui/material';
import { type CtaAnalyticsProps, CtaLink } from 'src/features/product-card/CTA/CtaLink';
type Props = {
  ctaAnalytics: CtaAnalyticsProps;
  creditCardOffer: CreditCardOffer;
  disableLink?: boolean;
  priority?: boolean;
};
export function Picture(t0) {
  const $ = _c(10);
  const {
    ctaAnalytics,
    creditCardOffer,
    disableLink: t1,
    priority: t2
  } = t0;
  const disableLink = t1 === undefined ? false : t1;
  const priority = t2 === undefined ? false : t2;
  const {
    cta,
    imageOptions,
    name,
    details: t3
  } = creditCardOffer;
  const {
    applyLink,
    reviewLink,
    isReview
  } = t3;
  let t4;
  if ($[0] !== applyLink || $[1] !== cta || $[2] !== ctaAnalytics || $[3] !== disableLink || $[4] !== imageOptions.small.url || $[5] !== isReview || $[6] !== name || $[7] !== priority || $[8] !== reviewLink) {
    t4 = !disableLink ? <CtaLink type="PRODUCT_IMAGE" analytics={ctaAnalytics} href={isReview ? reviewLink : applyLink} isReview={isReview} rel={cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined} target={isReview ? "_self" : "_blank"} finishType={isReview ? FinishType.InternalContent : FinishType.ExternalApplication} sx={{
      display: "flex",
      textDecoration: "none",
      position: "relative",
      width: 106,
      height: 66,
      "&:focus": {
        borderRadius: "4px;"
      }
    }} parameterActions={isReview ? [] : [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH]}><CdnImage fill={true} src={imageOptions.small.url} alt={`${name} Image`} sizes={IMAGE_SIZES.SUMMARY_TABLE_CARD} priority={priority} style={{
        objectFit: "contain"
      }} /></CtaLink> : <Box sx={{
      display: "flex",
      textDecoration: "none",
      position: "relative",
      width: 106,
      height: 66,
      "&:focus": {
        borderRadius: "4px;"
      }
    }}><CdnImage fill={true} src={imageOptions.small.url} alt={`${name} Image`} sizes={IMAGE_SIZES.SUMMARY_TABLE_CARD} priority={priority} style={{
        objectFit: "contain"
      }} /></Box>;
    $[0] = applyLink;
    $[1] = cta;
    $[2] = ctaAnalytics;
    $[3] = disableLink;
    $[4] = imageOptions.small.url;
    $[5] = isReview;
    $[6] = name;
    $[7] = priority;
    $[8] = reviewLink;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}